let mapClass;

export default {

	host() {
		return '';
	},

    wsHost() {
        return '';
    },
	
	base() {
		return '/rest';
    },
    
    wsBase() {
        return '/rest';
    },

    map() {
        return {
            lat: 54.8998811,
            lon: 52.2995088,
            zoom: 10
        };
    },

    mapClass(value) {
        if (undefined !== value)
            mapClass = value;
        return mapClass;
    },
	
	token(value) {
        if (undefined !== value) {
            localStorage['talitrum.session.token'] = value;
            // set token expiration date
            // to one day forward (86400 second
            // per day and 1000ms per second)
            localStorage['talitrum.session.tokenExpirationDate'] = new Date().getTime() + 30 * 86400 * 1000;
        }
        
        let expirationDate = localStorage['talitrum.session.tokenExpirationDate'];
        if (expirationDate) {
            // convert to long
            expirationDate = parseInt( expirationDate );
            // expired?
            if (new Date() > new Date( expirationDate ))
                return null;
        }
        
		return localStorage['talitrum.session.token'];
    },

    mapExtent(value) {
        if (undefined !== value)
            localStorage['talitrum.session.map.extent'] = JSON.stringify( value );

        const stringValue = localStorage['talitrum.session.map.extent']; 
        return stringValue && JSON.parse( stringValue );
    },
    
    languages(value) {
        if (undefined !== value)
            localStorage['talitrum.session.languages'] = JSON.stringify( value );

        const stringValue = localStorage['talitrum.session.languages']; 
        return stringValue && JSON.parse( stringValue );
    },

    timezones(value) {
        if (undefined !== value)
            localStorage['talitrum.session.timezones'] = JSON.stringify( value );

        const stringValue = localStorage['talitrum.session.timezones']; 
        return stringValue && JSON.parse( stringValue );
    },
    
    locale(value) {
        if (undefined !== value)
            localStorage['talitrum.locale'] = value;
            
        return localStorage['talitrum.locale'];
    },

    title(value) {
        if (undefined !== value)
            this.title_ = value;

        return this.title_;
    },
    
    user(value) {
        if (undefined !== value)
            localStorage['talitrum.session.userName'] = value;
            
        return localStorage['talitrum.session.userName'];
    },

    userId(value) {
        if (undefined !== value)
            localStorage['talitrum.session.userId'] = value;
            
        return localStorage['talitrum.session.userId'];
    },

    role(value) {
        if (undefined !== value)
            localStorage['talitrum.session.roleId'] = value;
            
        return localStorage['talitrum.session.roleId'];
    },

    roleCode(value) {
        if (undefined !== value)
            localStorage['talitrum.session.roleCode'] = value;
            
        return localStorage['talitrum.session.roleCode'];
    },

    privileges(value) {
        if (undefined !== value)
            localStorage['talitrum.session.rolePrivileges'] = JSON.stringify(
                Object.keys( value ).filter( key => [true, 't'].includes( value[key] ) ) );

        return localStorage['talitrum.session.rolePrivileges']
            ? JSON.parse( localStorage['talitrum.session.rolePrivileges'] )
            : [];
    },

    cluster(value) {
        if (undefined !== value)
            localStorage['talitrum.session.clusterId'] = JSON.stringify( value );
            
        value = localStorage['talitrum.session.clusterId'];
        return value !== undefined
            ? JSON.parse( value )
            : value;
    },

    clusters(value) {
        if (undefined !== value)
            localStorage['talitrum.session.clusters'] = JSON.stringify( value );
            
        value = localStorage['talitrum.session.clusters'];
        return value !== undefined
            ? JSON.parse( value )
            : value;
    },

    organization(value) {
        if (typeof value === 'string')
            if ('null' === value)
                delete localStorage['talitrum.session.organizationId'];
            else if ('undefined' === value)
                delete localStorage['talitrum.session.organizationId'];
            else
                localStorage['talitrum.session.organizationId'] = value;
        else if (null === value)
            delete localStorage['talitrum.session.organizationId'];
        else if (undefined !== value)
            localStorage['talitrum.session.organizationId'] = value;
            
        if (localStorage['talitrum.session.organizationId'])
            return +localStorage['talitrum.session.organizationId'];

        return undefined;
    },

    orgs(value) {
        if (null === value)
            delete localStorage['talitrum.session.orgs'];
        else if (undefined !== value)
            localStorage['talitrum.session.orgs'] = JSON.stringify( value );

        if (localStorage['talitrum.session.orgs'])
            return JSON.parse( localStorage['talitrum.session.orgs'] || '[]' );

        return undefined;
    },

	url(url, { addToken = true, addBase = true } = {}) {
		if ('/' !== url.charAt( 0 ))
			url = '/' + url;

        url = addBase
            ? this.host() + this.base() + url
            : this.host() + url;
        
        let token = this.token();
        if (addToken && token)
            url = this.add( url, 'token', this.token() );
          
        url = this.add( url, 'lang', this.locale() );
		
		return url;
	},
	
	add(url, name, value) {
        let hash = '';
        if (~url.indexOf( '#' ))
            hash = url.substr( url.indexOf( '#' ) ),
            url = url.substr( 0, url.indexOf( '#' ) );

		url += ~url.indexOf( '?' ) ? '&' : '?';
        url += name + '=' + encodeURIComponent( value ).replace( /,/g, '%2C' );
        
        if (hash)
            url += hash;

		return url;
	}

};


// WEBPACK FOOTER //
// ./src/js/config.js